import React, {Component} from 'react';
import {
    Card,
    CardHeader,
    CardText
} from 'material-ui/Card';
import Chip from 'material-ui/Chip';
import './timeline.css';

class TimelineComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
          expanded1: false,
          expanded2: false,
          expanded3: false
        };
    }

    async componentDidMount() {}

    componentWillUnmount() {}

    handleExpandChange = (expanded1) => {
      this.setState({expanded1: expanded1});
    };

    handleExpandChange2 = (expanded2) => {
      this.setState({expanded2: expanded2});
    };

    handleExpandChange3 = (expanded3) => {
      this.setState({expanded3: expanded3});
    };

    handleExpand = () => {
      this.setState({expanded: true});
    };

    handleExpand2 = () => {
      this.setState({expanded2: true});
    };

    handleExpand3 = () => {
      this.setState({expanded3: true});
    };

    handleReduce = () => {
      this.setState({expanded1: false});
    };

    handleReduce2 = () => {
      this.setState({expanded2: false});
    };

    handleReduce3 = () => {
      this.setState({expanded3: false});
    };
    render() {
        return (
            <div className="timeline">
              <p className="headline">Working experience</p>
                  <div className="timeline-entry">
                    <Card expanded={this.state.expanded1} onExpandChange={this.handleExpandChange}>
                        <CardHeader title="Senior Consultant" subtitle="Apps Associates Pvt. Ltd."
                          actAsExpander={true} showExpandableButton={true}/>
                        <CardText expandable={true}>
                            since	October	2017. Testing of Microservices, UI/UX, Performance and DevOps.
                            <br/><br/>
                              <div className="timeline-entries">
                                <div className="timeline-entry-chip">
                                  <Chip>Protractor, Selenium</Chip>
                                </div>
                                <div className="timeline-entry-chip">
                                  <Chip>Docker</Chip>
                                </div>
                                <div className="timeline-entry-chip">
                                  <Chip>CucumberJS</Chip>
                                </div>
                                <div className="timeline-entry-chip">
                                  <Chip>Rest-Assured</Chip>
                                </div>
                                <div className="timeline-entry-chip">
                                  <Chip>Jmeter</Chip>
                                </div>
                                <div className="timeline-entry-chip">
                                  <Chip>Kubernetes</Chip>
                                </div>
                                <div className="timeline-entry-chip">
                                  <Chip>JIRA, Github</Chip>
                                </div>
                                <div className="timeline-entry-chip">
                                  <Chip>Fortify, Black-Duck</Chip>
                                </div>
                              </div>
                        </CardText>
                    </Card>
                  </div>
                  <div className="timeline-entry">
                  <Card expanded={this.state.expanded2} onExpandChange={this.handleExpandChange2}>
                      <CardHeader title="SDET" subtitle="Innotical Solutions Pvt. Ltd."
                        actAsExpander={true} showExpandableButton={true}/>
                      <CardText expandable={true}>
                          March 2017 - September 2017. Testing of Microservices, UI/UX, Performance and DevOps of various products.

                          <div className="timeline-entries">
                            <div className="timeline-entry-chip">
                              <Chip>Protractor,Selenium</Chip>
                            </div>
                            <div className="timeline-entry-chip">
                              <Chip>Postman</Chip>
                            </div>
                            <div className="timeline-entry-chip">
                              <Chip>Jasmine</Chip>
                            </div>
                            <div className="timeline-entry-chip">
                              <Chip>Python</Chip>
                            </div>
                            <div className="timeline-entry-chip">
                              <Chip>Django</Chip>
                            </div>
                            <div className="timeline-entry-chip">
                              <Chip>Jenkins</Chip>
                            </div>
                            <div className="timeline-entry-chip">
                              <Chip>Open Office</Chip>
                            </div>
                          </div>
                      </CardText>
                  </Card>
                </div>
                <div className="timeline-entry">
                  <Card expanded={this.state.expanded3} onExpandChange={this.handleExpandChange3}>
                      <CardHeader title="Senior Calc. Automation Spec." subtitle="Aon (formerly Aon-Hewitt)"
                        actAsExpander={true} showExpandableButton={true}/>
                      <CardText expandable={true}>
                          November 2012	-	February	2017. Implementation,Maintenance & Testing of client provisions in Aon's Pension calculation system.

                          <div className="timeline-entries">
                            <div className="timeline-entry-chip">
                              <Chip>Excel</Chip>
                            </div>
                            <div className="timeline-entry-chip">
                              <Chip>IBM Smalltalk-80</Chip>
                            </div>
                            <div className="timeline-entry-chip">
                              <Chip>IBM Mainframe</Chip>
                            </div>
                            <div className="timeline-entry-chip">
                              <Chip>SQL</Chip>
                            </div>
                            <div className="timeline-entry-chip">
                              <Chip>Lotus Notes</Chip>
                            </div>
                          </div>
                      </CardText>
                  </Card>
                </div>
            </div>
        );
    }
}

export default TimelineComponent;



// WEBPACK FOOTER //
// ./src/components/timeline/timeline.jsx